import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOrganization } from '@/hooks/useOrganization';
import { Loader2 } from 'lucide-react';

interface OwnerOnlyRouteProps {
  children: ReactNode;
}

export function OwnerOnlyRoute({ children }: OwnerOnlyRouteProps) {
  const { membership, isOwner, isLoading } = useOrganization();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  // Allow access if user has no organization (standalone) or is the owner
  const hasNoOrganization = !membership;
  if (!hasNoOrganization && !isOwner) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
